module.exports = __webpack_public_path__ + "static/media/background1.0e236107.jpg";